import {useEffect, useState} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {getProbeSummary} from '../redux/portfolio.selector';

export function useGetValue(probeIdsArr, closedHeader) {
  let probes;
  if (!closedHeader) {
    probes = probeIdsArr?.map(id => {
      let liveState = useSelector(({liveReducer}) => {
        const probe = {
          ...(liveReducer?.byIds?.[id] || {}),
        };
        delete probe['volume'];
        delete probe['timestamp'];
        delete probe['channel'];
        return probe;
      }, shallowEqual);
      let livePortfolio = useSelector(
        ({portfolioReducer}) => portfolioReducer?.data1?.[id],
      );

      return getProbeSummary(livePortfolio, liveState);
    });
  }

  return {probes};
}
